import {ProgressCircle} from '@github-ui/progress-circle'
import {TriangleRightIcon} from '@primer/octicons-react'
import {Octicon} from '@primer/react/deprecated'
import type {TokenProps} from '@primer/styled-react'
import {Token} from '@primer/styled-react'
import {clsx} from 'clsx'

import styles from './SubIssuesSummaryToken.module.css'

interface Progress {
  total: number
  completed: number
  percentCompleted: number
}

export interface SubIssueCompletionTokenProps extends Omit<TokenProps, 'leadingVisual' | 'text' | 'ref'> {
  progress: Progress
}

export function SubIssuesSummaryToken({
  progress: {total, completed, percentCompleted},
  ...tokenProps
}: SubIssueCompletionTokenProps) {
  const expandOnHover = (tokenProps.as === 'button' && !tokenProps.disabled) || tokenProps.as === 'a'

  return (
    <Token
      leadingVisual={() => <ProgressCircle percentCompleted={percentCompleted} size={14} />}
      text={
        <>
          <span>{`${completed} / ${total}`}</span>
          {expandOnHover && (
            <Octicon icon={TriangleRightIcon} className={clsx('triangle', styles.expandTriangleIcon)} />
          )}
        </>
      }
      {...tokenProps}
      sx={{
        '&:hover, &:focus': expandOnHover
          ? {
              '.triangle': {},
            }
          : {},

        ...tokenProps.sx,
      }}
      className={styles.SubIssuesSummaryToken}
    />
  )
}

try{ SubIssuesSummaryToken.displayName ||= 'SubIssuesSummaryToken' } catch {}